/* eslint semi:0 */
import { getIsNativeApp } from '../../utils/ua'
import { taboolaScriptConfig } from './taboolaScriptConfig'
import { getGtmScriptConfig } from './gtmScriptConfig'
import { queryString } from '../../utils/window'
import { warn } from '../../application/console'
import { noop, makeSafeFn } from '../../utils/fn'
import { registerUtils } from '../../application/nm'
import facebookPixel from './facebookPixelScript'
import headerBidder from './headerBidderScriptConfig'
import { iterate as iterateObject } from '../../utils/object'
import { browsiScriptConfig as browsi } from './browsiScriptConfig'
import { getInfluencerId } from '../../utils/pageContext'

import {
  get as getFromPdo,
  getIsEmbededPost,
  getIsTopX,
  getIsSlideshow,
  getIsHybrid,
  getGTMIds,
  getGTMData,
} from '../../application/pageDataObject'
import { ready as onGoogleSearchActionsReady } from '../../organizedByType/actions/googleSearchActions'

const { trs_id: trafficSrcId } = queryString
const affiliateId = getInfluencerId()

const externalScriptsConfig = {
  facebookPixel,
  browsi,

  socialMiner: {
    src: 'https://plugins.soclminer.com.br/v3/sdk/all.min.js',
    beforeLoad() {
      window.soclInit = function() {
        socl.start('9213176e-a56e-454f-9366-e39ddfe3ad75')
      }
    },
  },

  reactful: {
    src: 'https://visitor.reactful.com/dist/main.rtfl.js',
    beforeLoad() {
      window._rctfl = window._rctfl || { c: [] }
      window._rctfl.c.push('514992')
    },
  },

  connatixMobile: {
    src: 'https://cdn.connatix.com/min/connatix.renderer.infeed.min.js',
    'data-connatix-token': '426ec5ef-24e0-4e61-91d2-fecda500a9fd',
  },

  connatixDesktop: {
    src: 'https://cdn.connatix.com/min/connatix.renderer.infeed.min.js',
    'data-connatix-token': '84120b7a-1315-4539-939a-95fcd2e6ac1d',
  },

  googleAnalytics: {
    src: 'https://www.google-analytics.com/analytics.js',
    beforeLoad() {
      window.GoogleAnalyticsObject = 'ga'
      const ga = (window.ga =
        window.ga ||
        function setGoogleAnalyticsQ() {
          ;(ga.q = ga.q || []).push(arguments)
        })
      ga.l = 1 * new Date()
      ga('create', getFromPdo('config.google_analytics.account_id'), 'auto')
      // for double-click: https://support.google.com/analytics/answer/3450482
      ga('require', 'displayfeatures')
    },
  },

  gtmAnalytics: getGtmScriptConfig(getGTMIds(), getGTMData()),

  comscore: {
    src: 'https://sb.scorecardresearch.com/beacon.js',
    beforeLoad() {
      window._comscore = window._comscore || []
      window._comscore.push({
        ...getFromPdo('config.comscore.account'),
      })
    },
  },
  agof: { src: 'https://script.ioam.de/iam.js' },

  facebook: {
    src: `https://connect.facebook.net/${getFromPdo('config.facebook.sdk_locale', 'en_US')}/sdk.js`,
    onload: makeSafeFn(function onFacebookSdkLoaded() {
      window.FB.init({
        appId: getFromPdo('config.facebook.app_id'),
        version: getFromPdo('config.facebook.api_version'),
        cookie: true,
        xfbml: true,
      })
    }),
  },

  twitter: { src: 'https://platform.twitter.com/widgets.js' },
  riddle: { src: 'https://www.riddle.com/files/js/embed.min.js' },

  googleSearch: {
    src: `https://www.google.com/cse/cse.js?cx=${getFromPdo('config.google_search.cx')}`,
    beforeLoad() {
      window.__gcse = { callback: onGoogleSearchActionsReady }
    },
  },

  zoomd: {
    src: `https://zdwidget3-bs.sphereup.com/zoomd/SearchUi/Script?clientId=${getZoomdConfig()}`,
    name: 'zoomd',
  },

  taboolaScriptConfig,
  headerBidder,

  dfp: {
    src: 'https://www.googletagservices.com/tag/js/gpt.js',
    beforeLoad() {
      const inAppConditions =
        getIsHybrid() && !getIsEmbededPost() && !affiliateId && !getIsTopX() && !getIsSlideshow()
      return getIsNativeApp() ? inAppConditions : true
    },
  },

  youtube: {
    src: 'https://www.youtube.com/iframe_api',
    name: 'youtubeAPI',
  },

  freshEightMX: {
    src: 'https://fresh8.co/391499/embed.js?view=Article',
    name: 'freshEightMX',
  },
  freshEightGB: {
    src: 'https://fresh8.co/874248/embed.js?view=article',
    name: 'freshEightGB',
  },

  jwplayer: {
    src(playerId) {
      return `https://content.jwplatform.com/libraries/${playerId}.js`
    },
  },

  playbuzz: { src: 'https://cdn.playbuzz.com/widget/feed.js' },

  monti: {
    src() {
      return 'https://www.oo-syringe.com/prod/monti_api_player/monti.1.0.0.js'
    },
  },

  newscorp: {
    src: '//www.ballball.com/static/js/enhanced_player/1.1/enhanced_player_host.js',
  },

  perimeterX: {
    src: 'https://client.a.pxi.pub/PXszbKVa5M/main.min.js',
    beforeLoad() {
      Object.assign(window, {
        _pxAppId: 'PXszbKVa5M',
        _pxParam1: affiliateId,
        _pxParam3: trafficSrcId,
        _pxPubHost: 'collector.a',
      })
    },
  },

  jQuery: { src: 'https://code.jquery.com/jquery-2.1.4.min.js' },

  pptracker: {
    src: '//d3ewtlvykuetpq.cloudfront.net/tracker.js',
  },
}

export const SCRIPT_LOADER_CONF_DEFAULTS = {
  defer: true,
  onload: noop,
  beforeLoad() {
    return true
  },
}

function getZoomdConfig() {
  return typeof getFromPdo('config.zoomd_search') !== 'undefined'
    ? getFromPdo('config.zoomd_search')
    : getFromPdo('zoomd_search')
}

function addNamePropertyToScriptConf(scriptConf, scriptName) {
  const scriptConfName = scriptConf.name || scriptName
  const { src } = scriptConf
  if (!src) {
    const falsySrcErrorMessage = `Falsy src ('${src}') in scriptConf name '${scriptConfName}'!`
    warn(falsySrcErrorMessage, { scriptConf, scriptConfName })
  }
  scriptConf.name = scriptConfName
}

Object.assign(iterateObject(externalScriptsConfig, addNamePropertyToScriptConf), {
  defaults: SCRIPT_LOADER_CONF_DEFAULTS,
})

registerUtils({ externalScriptsConfig })

export { externalScriptsConfig }



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/config/externalScripts.js